module.exports = __webpack_public_path__ + "img/colin.be3cf0f4.jpg";